(ns rothko.media.component
  (:require [reagent.core :as reagent]
            [rothko.audio.mini-player.component :refer [mini-player]]
            [rothko.modal.component :refer [modal]]))

(defn media
  [{:keys [on-close]
    :or {on-close (constantly :noop)}
    :as props}
   & children]
  (let [!modal-open (reagent/atom false)
        open-handler (fn [ev]
                       (reset! !modal-open true)
                       (.stopPropagation ev))
        close-handler (fn []
                        (reset! !modal-open false)
                        (on-close))]
    (fn [{:keys [alt dismissable? on-load src type]
          :or {alt ""
               dismissable? true
               on-load (constantly :noop)}
          :as props}]
      (case type
        :image [:div.media
                (when @!modal-open
                  [modal {:dismissable? dismissable?
                          :on-close close-handler}
                   [:img {:src src
                          :on-click close-handler}]])
                [:img.media__image
                 {:on-click open-handler
                  :on-load on-load
                  :alt alt
                  :src src}]]
        :audio (into [mini-player props] children)))))
